import { render } from "./TableHead.vue?vue&type=template&id=73e3c339"
import script from "./TableHead.vue?vue&type=script&lang=js"
export * from "./TableHead.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ERP SISTEMA POS\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__